import { useContext, useState } from "react"

import {
    Button,
    ButtonGroup,
    Card,
    CardActionArea,
    CardContent,
    CardMedia,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    makeStyles,
    Typography,
} from "@material-ui/core"
import { Add, ArrowForwardIos, Remove, Stars } from "@material-ui/icons"
import Skeleton from "@material-ui/lab/Skeleton"

import Promocional from "./promocional"

import Comida from "../../../assets/comida.svg"
import Megafone from "../../../assets/megafone.svg"
import SiteContext from "../../../contexts/SiteContext"
import useCustomHistory from "../../../hooks/useCustomHistory"
import {
    formatarParaDinheiro,
    identificarEstabelecimentoSelecionado,
} from "../../../services/functions"

const useStyles = makeStyles(theme => ({
    actionArea: {
        height: "100%",
    },
    content: {
        ["@media (max-width:480px)"]: {
            padding: "8px",
        },
    },
    rootProduto: {
        height: "100%",
        padding: 0,
    },
    nomeProduto: {
        fontSize: "1.25em",
        display: "block",
    },
    descricaoProduto: {
        display: "block",
    },
    valorProduto: {
        display: "block",
        color: "#28a745",
        fontWeight: "500",
        fontSize: "20px",
    },
    aPartirDe: {
        fontSize: "12px",
        color: "#353535",
    },
    produtoPromocional: {
        position: "absolute",
        top: "3px",
        left: "5px",
        width: "0.75em",
        height: "0.75em",
        color: "#ffc107",
    },
    valorProdutoPromocional: {
        textDecoration: "line-through",
        color: "#dc3545",
        fontWeight: "500",
        fontSize: "14px",
        marginLeft: "0.25em",
    },
    inputAdicionarInicial: {
        width: "25px",
        textAlign: "center",
        border: "1px solid rgba(0, 0, 0, 0.12)",
    },
    listLayout: {
        display: "flex",
        flexDirection: "row",
        height: "100%",
    },
    listText: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        padding: "min(1.5em, 4%) 3.5%",
        justifyContent: "space-around",
    },
    imagemProdutoList: {
        margin: "0.5rem 1rem",
        objectFit: "contain",
        height: "7.5rem",
        backgroundSize: "contain",
        flex: "0 0 25%",
    },
    imagemProdutoGrid: {
        height: "140px",
        backgroundSize: "contain",
    },
    fazerZoom: {
        transform: "scale(1.15)",
    },
    grupoBotoes_container: {
        padding: "0.5em 0",
        [theme.breakpoints.down("xs")]: {
            padding: 0,
        },
    },
    grupoBotoes_quantidade: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        border: "1px rgba(0, 0, 0, 0.23) solid",
    },
    grupoBotoes_botaoMenos: {
        backgroundColor: props => (props.quantidade <= 0 ? "#7e7e7e" : "#dc354596"),
        "&:hover": {
            backgroundColor: props => (props.quantidade <= 0 ? "#7e7e7e" : "#dc354596"),
        },
    },
    grupoBotoes_botaoMais: {
        backgroundColor: props =>
            props.qntMaximaProdutos
                ? props.quantidade >= props.qntMaximaProdutos
                    ? "#7e7e7e"
                    : "#28a74596"
                : "#28a74596",
        "&:hover": {
            backgroundColor: props =>
                props.qntMaximaProdutos
                    ? props.quantidade >= props.qntMaximaProdutos
                        ? "#7e7e7e"
                        : "#28a74596"
                    : "#28a74596",
        },
    },
}))

const GrupoBotoesAdicionarRemover = ({
    produto,
    removerProdutoCarrinho,
    adicionarProdutoCarrinho,
}) => {
    const classes = useStyles({
        quantidade: produto.quantidade,
        qntMaximaProdutos: produto.qntMaximaProdutos,
    })

    return (
        <ButtonGroup className={classes.grupoBotoes_container}>
            <Button
                size="small"
                aria-label="reduce"
                onClick={() => removerProdutoCarrinho(produto)}
                disabled={produto.quantidade === 0}
                className={classes.grupoBotoes_botaoMenos}
            >
                <Remove fontSize="small" />
            </Button>
            <span className={classes.grupoBotoes_quantidade}>
                <Typography>{produto.quantidade}</Typography>
            </span>
            <Button
                aria-label="increase"
                size="small"
                onClick={() => adicionarProdutoCarrinho(produto)}
                disabled={produto.quantidade === produto.qntMaximaProdutos}
                className={classes.grupoBotoes_botaoMais}
            >
                <Add fontSize="small" />
            </Button>
        </ButtonGroup>
    )
}

const DialogAvisoExibicao = props => {
    const handleClose = () => props.setOpenDialogAviso(false)

    return (
        <Dialog open={props.openDialogAviso} onClose={handleClose}>
            <DialogTitle>
                <IconButton className="setaVoltarModal" onClick={handleClose}>
                    <ArrowForwardIos />
                </IconButton>
                {props.produto.nome}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>{props.produto.descricao}</DialogContentText>
            </DialogContent>
        </Dialog>
    )
}

function ProdutoCard({ layout, produto, adicionarProdutoCarrinho, removerProdutoCarrinho }) {
    const { estabelecimentoAtual, aplicativoDados } = useContext(SiteContext)

    const classes = useStyles()
    const history = useCustomHistory()

    const [openDialogAviso, setOpenDialogAviso] = useState(false)

    if (produto.nome === "Adicionais Associados") return null

    const handleClickProduto = () => {
        if (produto.produtoExibicao) {
            setOpenDialogAviso(true)
            return
        }

        history.push(
            `/produto/${produto.id}`,
            identificarEstabelecimentoSelecionado(aplicativoDados)[1]
        )
    }

    const descricaoFormatada = produto.descricao
        ? layout !== "AdicionarInicial" && produto.descricao.length > 80
            ? produto.descricao[0] + produto.descricao.substring(1, 80).toLowerCase() + " [...]"
            : produto.descricao[0] +
              produto.descricao.substring(1, produto.descricao.length).toLowerCase()
        : ""

    switch (layout) {
        case "AdicionarInicial":
            return (
                <>
                    <Grid
                        item
                        xs={6}
                        md={4}
                        lg={4}
                        key={produto.id}
                        id={`produto-${produto.id}`}
                        className="CardProdutoCol"
                        style={{ textAlign: "center" }}
                    >
                        <Card className={classes.rootProduto}>
                            <CardMedia
                                className={`${produto.urlImagem ? "" : "opacity05"} ${
                                    classes.imagemProdutoGrid
                                } ${
                                    estabelecimentoAtual.fazerZoomExibicaoFoto
                                        ? classes.fazerZoom
                                        : ""
                                }`}
                                image={
                                    produto.urlImagem
                                        ? produto.urlImagem
                                        : produto.produtoExibicao
                                        ? Megafone
                                        : /**Prato */ Comida
                                }
                                title={produto.nome}
                            />

                            {produto.promocional && (
                                <Stars className={classes.produtoPromocional} />
                            )}

                            <CardContent className={classes.content}>
                                <Typography
                                    gutterBottom
                                    variant="h5"
                                    component="span"
                                    className={`nomeProduto ${classes.nomeProduto}`}
                                >
                                    {produto.nome}
                                </Typography>
                                <Typography
                                    className={classes.descricaoProduto}
                                    variant="subtitle2"
                                    color="textSecondary"
                                    component="span"
                                >
                                    {descricaoFormatada}
                                </Typography>

                                {produto.produtoExibicao ? (
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                        className={classes.valorProduto}
                                        component="span"
                                    >
                                        Aviso
                                    </Typography>
                                ) : (
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                        className={classes.valorProduto}
                                        component="span"
                                    >
                                        {produto.valorRealCalculado > 0 ? (
                                            <span>
                                                {aplicativoDados?.mostrarAPartirDe && (
                                                    <span className={classes.aPartirDe}>
                                                        a partir de{" "}
                                                    </span>
                                                )}
                                                {formatarParaDinheiro(produto.valorRealCalculado)}
                                            </span>
                                        ) : produto.valorRealCalculado == 0 ? null : (
                                            <Skeleton variant="rect" width={80} height={30} />
                                        )}
                                        {produto.valorDe && produto.valorDeCalculado > 0 ? (
                                            <span className={classes.valorProdutoPromocional}>
                                                {formatarParaDinheiro(produto.valorDeCalculado)}
                                            </span>
                                        ) : (
                                            ""
                                        )}
                                    </Typography>
                                )}

                                {!produto.produtoExibicao && (
                                    <GrupoBotoesAdicionarRemover
                                        produto={produto}
                                        adicionarProdutoCarrinho={adicionarProdutoCarrinho}
                                        removerProdutoCarrinho={removerProdutoCarrinho}
                                    />
                                )}
                            </CardContent>
                        </Card>
                    </Grid>
                    {produto.produtoExibicao ? (
                        <DialogAvisoExibicao
                            produto={produto}
                            openDialogAviso={openDialogAviso}
                            setOpenDialogAviso={setOpenDialogAviso}
                        />
                    ) : null}
                </>
            )
        case "List":
            return (
                <>
                    <Grid item xs={12} md={6} lg={6} key={produto.id} id={`produto-${produto.id}`}>
                        <Card className={classes.rootProduto} onClick={handleClickProduto}>
                            <CardActionArea className={classes.listLayout}>
                                <div className={classes.listText}>
                                    <Typography
                                        variant="h5"
                                        component="span"
                                        className={classes.nomeProduto}
                                    >
                                        {produto.nome}
                                    </Typography>
                                    <Typography
                                        variant="subtitle2"
                                        component="span"
                                        color="textSecondary"
                                        className={classes.descricaoProduto}
                                    >
                                        {descricaoFormatada}
                                    </Typography>
                                    {produto.produtoExibicao ? (
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                            className={classes.valorProduto}
                                            component="span"
                                        >
                                            Aviso
                                        </Typography>
                                    ) : (
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                            className={classes.valorProduto}
                                            component="span"
                                        >
                                            {produto.valorRealCalculado > 0 ? (
                                                <span>
                                                    {aplicativoDados?.mostrarAPartirDe ? (
                                                        <span className={classes.aPartirDe}>
                                                            a partir de{" "}
                                                        </span>
                                                    ) : null}
                                                    {formatarParaDinheiro(
                                                        produto.valorRealCalculado
                                                    )}
                                                </span>
                                            ) : produto.valorRealCalculado == 0 ? null : (
                                                <Skeleton variant="rect" width={80} height={30} />
                                            )}
                                            {produto.valorDe && produto.valorDeCalculado > 0 ? (
                                                <span className={classes.valorProdutoPromocional}>
                                                    {formatarParaDinheiro(produto.valorDeCalculado)}
                                                </span>
                                            ) : (
                                                ""
                                            )}
                                        </Typography>
                                    )}
                                </div>
                                <CardMedia
                                    className={`${produto.urlImagem ? "" : "opacity05"} ${
                                        classes.imagemProdutoList
                                    } ${
                                        estabelecimentoAtual.fazerZoomExibicaoFoto
                                            ? classes.fazerZoom
                                            : ""
                                    }`}
                                    image={
                                        produto.urlImagem
                                            ? produto.urlImagem
                                            : produto.produtoExibicao
                                            ? Megafone
                                            : Comida
                                    }
                                    title={produto.nome}
                                />
                                <Promocional
                                    promocional={produto.promocional}
                                    corSitePrimaria={aplicativoDados.corSitePrimaria}
                                />
                            </CardActionArea>
                        </Card>
                    </Grid>
                    {produto.produtoExibicao ? (
                        <DialogAvisoExibicao
                            produto={produto}
                            openDialogAviso={openDialogAviso}
                            setOpenDialogAviso={setOpenDialogAviso}
                        />
                    ) : null}
                </>
            )

        case "Grid":
            return (
                <>
                    <Grid
                        item
                        xs={6}
                        sm={6}
                        md={4}
                        lg={4}
                        xl={3}
                        key={produto.id}
                        id={`produto-${produto.id}`}
                    >
                        <Card
                            className={classes.rootProduto}
                            onClick={handleClickProduto}
                            elevation={2}
                        >
                            <CardActionArea className={classes.actionArea}>
                                <CardMedia
                                    className={`${produto.urlImagem ? "" : "opacity05"} ${
                                        classes.imagemProdutoGrid
                                    } ${
                                        estabelecimentoAtual.fazerZoomExibicaoFoto
                                            ? classes.fazerZoom
                                            : ""
                                    }`}
                                    image={
                                        produto.urlImagem
                                            ? produto.urlImagem
                                            : produto.produtoExibicao
                                            ? Megafone
                                            : Comida
                                    }
                                    title={produto.nome}
                                />
                                {produto.promocional && (
                                    <Stars className={classes.produtoPromocional} />
                                )}
                                <CardContent>
                                    <Typography
                                        gutterBottom
                                        variant="h5"
                                        component="span"
                                        className={`nomeProduto ${classes.nomeProduto}`}
                                    >
                                        {produto.nome}
                                    </Typography>
                                    <Typography
                                        variant="subtitle2"
                                        color="textSecondary"
                                        component="span"
                                        className={classes.descricaoProduto}
                                    >
                                        {descricaoFormatada}
                                    </Typography>
                                    {produto.produtoExibicao ? (
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                            className={classes.valorProduto}
                                            component="span"
                                        >
                                            Aviso
                                        </Typography>
                                    ) : (
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                            className={classes.valorProduto}
                                            component="span"
                                        >
                                            {produto.valorRealCalculado > 0 ? (
                                                <span>
                                                    {aplicativoDados?.mostrarAPartirDe ? (
                                                        <span className={classes.aPartirDe}>
                                                            a partir de{" "}
                                                        </span>
                                                    ) : null}
                                                    {formatarParaDinheiro(
                                                        produto.valorRealCalculado
                                                    )}
                                                </span>
                                            ) : produto.valorRealCalculado == 0 ? null : (
                                                <Skeleton variant="rect" width={80} height={30} />
                                            )}
                                            {produto.valorDe && produto.valorDeCalculado > 0 ? (
                                                <span className={classes.valorProdutoPromocional}>
                                                    {formatarParaDinheiro(produto.valorDeCalculado)}
                                                </span>
                                            ) : (
                                                ""
                                            )}
                                        </Typography>
                                    )}
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    {produto.produtoExibicao ? (
                        <DialogAvisoExibicao
                            produto={produto}
                            openDialogAviso={openDialogAviso}
                            setOpenDialogAviso={setOpenDialogAviso}
                        />
                    ) : null}
                </>
            )
    }
}

export default ProdutoCard
// export default memo(ProdutoCard)
